import {ShareholderListParams} from '../Model'
import {actionTypes} from './constants'

export const actions = {
  getShareholderRecords: (params: ShareholderListParams) => ({
    type: actionTypes.GET_SHAREHOLDER_RECORDS_START,
    payload: params,
  }),
  getShareholderRecordsSuccess: (data: any) => ({
    type: actionTypes.GET_SHAREHOLDER_RECORDS_SUCCESS,
    payload: data,
  }),
  getShareholderRecordsFinish: () => ({
    type: actionTypes.GET_SHAREHOLDER_RECORDS_FINISH,
  }),
}
